var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-export"},[_c('el-button',{attrs:{"loading":_vm.loading,"type":_vm.type,"icon":_vm.icon},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }